<div class="create-new-template-container">
    <mat-icon class="material-symbols-outlined create-new-template-container__icon--edit">
        edit
    </mat-icon>
    <div class="create-new-template-container--title">
        {{languageSettings.PSTWebCreateNewTemplateLabel}}
    </div>
    <text-field [value]="template.title"
                class="create-new-template-container__title--input"
                (changed)="valueChanged($event)">
    </text-field>
    <div class="create-new-template-container-buttons">
        <button (click)="closeDialog()"
                class="create-new-template-container-buttons__btn--cancel"
                mat-button>
            {{languageSettings.PSTWebCancelButtonLabel}}
        </button>

        <button (click)="createEnterpriseTemplate($event)"
                [disabled]="isDisabled"
                *ngIf="isSuperVisor"
                mat-button>
            <ng-template [ngIf]="!loading"
                         [ngIfElse]="loader">
                {{languageSettings.PSTWebSaveAsEnterprise}}
            </ng-template>
            <ng-template #loader>
                <loader [diameter]="30"
                        class="st-login-button-group--spinner"
                        [strokeWidth]="5"></loader>
            </ng-template>
        </button>
        <button (click)="createTeamTemplate($event)"
                [disabled]="isDisabled"
                *ngIf="isSuperVisor"
                mat-button>
            <ng-template [ngIf]="!loading"
                         [ngIfElse]="loader">
                {{languageSettings.PSTWebSaveAsTeam}}
            </ng-template>
            <ng-template #loader>
                <loader [diameter]="30"
                        class="st-login-button-group--spinner"
                        [strokeWidth]="5"></loader>
            </ng-template>
        </button>
        <button (click)="createPersonalTemplate($event)"
                [disabled]="isDisabled"
                class="create-new-template-container-buttons__btn--save"
                mat-button>
            <ng-template [ngIf]="!loading"
                         [ngIfElse]="loader">
                {{languageSettings.PSTWebSaveButtonLabel}}
            </ng-template>
            <ng-template #loader>
                <loader [diameter]="30"
                        class="st-login-button-group--spinner"
                        [strokeWidth]="5">
                </loader>
            </ng-template>
        </button>
    </div>
</div>